//import AppStore from '../../AppStore'

const userHomePath = () => {
  //const state = AppStore.store.getState()
  //const {user} = state
  return '/'
}

export default userHomePath



// WEBPACK FOOTER //
// ./src/routes/components/userHomePath.js